<template>
    <div class="row carousel-calendar">
        <div class="col-12 col-header-card">
            <span class="month-year">{{new Date(mesAnoAtual.substring(0,4), mesAnoAtual.substring(5,7),0).toLocaleString("PT-BR", { month: "long" })}} - {{mesAnoAtual.substring(0,4)}}</span>
            <CalendarIcon @click="toogleCalendar = !toogleCalendar" class="calendar-icon"/>
            <div class="month-picker" v-if="toogleCalendar">
                <v-date-picker
                    v-model="picker"
                    type="month"
                    locale="pt-BR"
                    :allowed-dates="val => mesesApontamentos.includes(val)"
                    @change="loadingDates(parseInt(picker.substring(5,7)), parseInt(picker.substring(0,4)))"
                ></v-date-picker>
            </div>
        </div>
        
        <div v-if="daysMonth.length > 0" class="calendar-info">
            <div class="col-12 col-calendar">
                
                <VueSlickCarousel
                    v-bind="settings"
                >
                    <button 
                        v-for="(day,index) in daysMonth " 
                        :key="index"
                        :id="`button ${index}`" 
                        :class="[
                        'card-day',
                        datasInconsistentes.includes(day.date) && 'error',
                        !datasApontamentos.includes(day.date) && 'disabled',
                        datasDivergencias.includes(day.date) && 'disabled',
                        dataSelecionada === day.date && !datasDivergencias.includes(day.date)  && 'active',
                        validaDia(day) == true && 'disabled',
                        ]" 
                        @click="atualizaDia(index, day.date)"

                    >
                        <span class="day">{{day.date.substring(8,11)}}</span>
                        <span class="dayOfWeek">{{day.dayOfWeek}}</span>
                    </button>
                    
                </VueSlickCarousel>
            </div> 
        </div>
           
    </div>
</template>

<script>
  import VueSlickCarousel from 'vue-slick-carousel'
  import 'vue-slick-carousel/dist/vue-slick-carousel.css'
  import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'
  import CalendarIcon from '@/assets/images/pages/calendar.svg'
export default {
    components: {
       VueSlickCarousel,
       CalendarIcon,
    },
    props: {
        mesAnoAtual: {
            default: '',
            type: String,
        },
        datasInconsistentes: {
            default: [],
            type: Array,
        },
        datasApontamentos: {
            default: [],
            type: Array,
        },
        mesesApontamentos: {
            default: [],
            type: Array,
        },
        dataSelecionada: {
            default: null,
            type: String,
        },
        datasDivergencias: {
            default: [],
            type: Array,
        }
        
    },
    data() {
        return {
            settings:{
                slidesToShow: 15,
                slidesToScroll: 1,
                dots:false,
                centerMode: false,
                arrows: false,
                swipeToSlide: true,  
                infinite: false,
                responsive: [
                    {breakpoint: 320,
                        settings: {
                            slidesToShow: 2,
                           
                        }
                    },
                    {breakpoint: 480,
                        settings: {
                            slidesToShow: 3,
                           
                        }
                    },
                    {breakpoint: 550,
                        settings: {
                            slidesToShow: 4,
                           
                        }
                    },
                    {breakpoint: 800,
                        settings: {
                            slidesToShow: 5,
                           
                        }
                    },
                    {breakpoint: 1000,
                        settings: {
                            slidesToShow: 7,
                           
                        }
                    },
                    {breakpoint: 1024,
                        settings: {
                            slidesToShow: 10,
                           
                        }
                    },
                    {breakpoint: 1200,
                        settings: {
                            slidesToShow: 11,
                           
                        }
                    },
                    {breakpoint: 1300,
                        settings: {
                            slidesToShow: 12,
                           
                        }
                    },
                    {breakpoint: 1500,
                        settings: {
                            slidesToShow: 13,
                           
                        }
                    },
                ]

            },
            daysMonth:[],
            picker:'',
            toogleCalendar:false
        };
    },
    methods: {
        validaDia(dia){
            const abilityList = JSON.parse(localStorage.getItem('userData')).ability;
            if (abilityList.find(element => element.action === 'manage')) {
                return false;
            }

            let maxDays = 7;
            const filteredSubjects = abilityList.filter(item => item.subject !== "basic");

            if (filteredSubjects.length === 1 && filteredSubjects[0].subject === 'operator'){
                maxDays = 30;
            }

            let dataApontamento = dia.date+' 00:00:00:00.000'
            let ultimoApontamento = this.datasApontamentos[0]+' 00:00:00:00.000'
            var data1 = new Date(dataApontamento);
            var data2 = new Date(ultimoApontamento);
            var timeDiff = Math.abs(data2.getTime() - data1.getTime());
            var diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24)); 
            if (data1 > data2){
                return true
            }
            if(diffDays > maxDays){
                return true
            }
            else{
                return false
            }
        },
        atualizaDia(index, data){
            this.$emit("atualizaUrl", `?dateFilter=${data}`)
        },
        loadingDates(mes, ano){
            this.daysMonth = []
            var semana = ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sab"];
            let qtdDias = new Date(ano, mes, 0).getDate();
            for (let i=1; i<=qtdDias; i++)  {
                var body = {
                    date: ano + '-' +  (mes<10 ?'0'+ mes : mes) + '-' + (i<10 ? '0' + i : i),
                    dayOfWeek: semana[new Date(ano,parseInt(mes-1),i).getDay()]
                }
                this.daysMonth.push(body)
            }
            this.toogleCalendar = false
            if(this.picker){
                this.$emit("atualizaUrl", `?monthFilter=${this.picker}`)
            }    
        }
    },
    mounted() {
        this.loadingDates(parseInt(this.mesAnoAtual.substring(5,7)),this.mesAnoAtual.substring(0,4));
        this.picker = this.mesAnoAtual
    }
    
};
</script>

<style lang="scss">

.carousel-calendar{
    border-bottom: 1px solid #CFC4BE;
    .col-header-card{
        display: flex;
        justify-content: space-between;
        padding-bottom: 0 !important;
        .month-year{
            font-family: 'Roboto';
            font-style: normal;
            font-weight: 600;
            font-size: 18px;
            line-height: 26px;
            color: #4C4541;
            text-transform: capitalize;
        }
        .calendar-icon{
            &:hover{
                cursor: pointer;
            }
        }
        .month-picker{
                position: absolute;
                z-index: 10;
                right: 12px;
                top: 38px;
            .v-picker{
                box-shadow: 0px 4px 24px rgba(58, 46, 38, 0.1);
                border-radius: 4px;
                .v-picker__title{
                    display: none;
                }
                .v-picker__body{
                    width: 225px !important;
                    .v-date-picker-header{
                        width: 225px;
                        .v-btn{
                            .v-btn__content{
                                .v-icon{
                                    &.mdi-chevron-left{
                                
                                        background-image: url("data:image/svg+xml;charset=utf8,%3Csvg width='10' height='10' viewBox='0 0 10 10' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M6.94583 0L8.125 1.17875L4.23375 5.00167L8.125 8.82125L6.94583 10L1.875 5.00167L6.94583 0Z' fill='%23998F8A'/%3E%3C/svg%3E") !important;
                                        background-position: center;
                                    }
                                    &.mdi-chevron-right{
                                        background-image: url("data:image/svg+xml;charset=utf8,%3Csvg width='10' height='10' viewBox='0 0 10 10' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cg clip-path='url(%23clip0_1470_24171)'%3E%3Cpath d='M3.05417 10L1.875 8.82125L5.76625 4.99833L1.875 1.17875L3.05417 0L8.125 4.99833L3.05417 10Z' fill='%23998F8A'/%3E%3C/g%3E%3Cdefs%3E%3CclipPath id='clip0_1470_24171'%3E%3Crect width='10' height='10' fill='white'/%3E%3C/clipPath%3E%3C/defs%3E%3C/svg%3E");
                                        background-position: center;
                                    }
                                }
                            }
                        }
                        .v-date-picker-header__value{
                            button{
                                font-family: 'Roboto';
                                font-style: normal;
                                font-weight: 600;
                                font-size: 14px;
                                line-height: 20px;
                                color: #4C4541;
                            }
                        }
                    }
                    .v-date-picker-table{
                        width: 225px;
                        height: auto !important;
                        padding:0 16px 8px;
                        td{
                            height: 50px !important;
                            .v-btn{
                                padding: 0;
                                border-radius: 50% !important;
                                height: 50px;
                                &:hover{
                                    background-color: #ece0db !important;
                                    opacity: 1;
                                
                                }
                                &::before{
                                    opacity: 0;
                                }
                                &.v-btn--outlined{
                                    border: none !important;
                                }
                                &.v-btn--active{
                                    &:hover{
                                        background-color: #974900 !important;
                                    }
                                    border: 1px solid #974900 !important;
                                    background-color: #974900 !important;
                                    .v-btn__content{
                                        color: #ffff;
                                    }
                                }
                                &.v-btn--disabled{
                                    .v-btn__content{
                                        color: #D3D3D3;
                                    }
                                }
                                .v-btn__content{
                                    font-family: 'Roboto';
                                    font-style: normal;
                                    font-weight: 400;
                                    font-size: 14px;
                                    line-height: 20px;
                                    color: #4C4541;
                                    text-transform: capitalize;
                                }
                            }
                        }
                        
                    }
                }

            }
        }
    }
    .calendar-info{
        width: 100% !important;
        .col-calendar{
            padding-top: 0 !important;
            padding-bottom: 0 !important;
            .slick-slider{
                margin: 16px 0;
                .slick-list{
                    max-width: 1585px;
                    .slick-slide{
                        width: 56px !important;
                        margin: 0 15px;
                        .card-day{
                            display: flex !important;
                            flex-direction: column;
                            align-items: center;
                            padding: 8px 16px;
                            border-radius: 6px;
                            background: transparent !important;
                            border: 1px solid transparent !important;
                            
                            .day{
                                font-family: 'Roboto';
                                font-style: normal;
                                font-weight: 600;
                                font-size: 18px;
                                line-height: 26px;
                                color: #4C4541;
                            }
                            .dayOfWeek{
                                font-family: 'Roboto';
                                font-style: normal;
                                font-weight: 400;
                                font-size: 14px;
                                line-height: 20px;
                                color: #4C4541;
                            }
                            &.disabled{
                                pointer-events: none !important;
                                .day,.dayOfWeek{
                                    color: #7E7570 !important;
                                }
                                &:hover{
                                    background-color: transparent !important;
                                    border: 1px solid transparent !important;
                                }
                                &:focus{
                                    background-color: transparent !important;
                                    border: 1px solid transparent !important;
                                }
                            }
                            &.error{
                                border: 1px solid #EF5350 !important;
                                .day,.dayOfWeek{
                                    color: #EF5350 !important;
                                }
                                &:hover{
                                    background-color:#FFEBEE !important;
                                    border: 1px solid #EF5350 !important;
                                    

                                }
                                &.active{
                                    background-color: #EF5350 !important;
                                    border: 1px solid #EF5350 !important;
                                    .day,.dayOfWeek{
                                        color: #ffff !important;
                                    }
                                    &:hover{
                                        background-color: #EF5350 !important;
                                        border: 1px solid #EF5350 !important;
                                        .day,.dayOfWeek{
                                            color: #ffff !important;
                                        }
                                    }
                                }
                                &.disabled{
                                    border: 1px solid transparent !important;
                                    pointer-events: none !important;
                                    .day,.dayOfWeek{
                                        color: #7E7570 !important;
                                    }
                                    &:hover{
                                        background-color: transparent !important;
                                        border: 1px solid transparent !important;
                                    }
                                    &:focus{
                                        background-color: transparent !important;
                                        border: 1px solid transparent !important;
                                    }
                                }
                            }
                            &:hover{
                                cursor: pointer;
                                border: 1px solid #FFEDE2 !important;
                                background-color: #FFEDE2 !important;
                                .day,.dayOfWeek{
                                    color: #974900;
                                }
                            }
                            &.active{
                                border: 1px solid #974900 !important;
                                background-color: #974900 !important;
                                .day,.dayOfWeek{
                                    color: #ffff !important;
                                }
                                &:hover{
                                    background-color:#974900 !important;
                                    border: 1px solid #974900 !important;
                                    

                                }
                            }
                            
                        }
                    }
                }
            }
        }
    }
}


</style>
